import santosh from '../images/others/santosh.jpeg'
import bike from '../images/cycle/bb.jpg'
import dev from '../images/others/devs.jpeg'
import boy from '../images/others/boy.jpg'
import football from '../images/others/football.jpg'
import ground from '../images/others/ground.jpg';
import cricket from '../images/others/cricket.jpg'
import blood from '../images/others/blood.jpg';
import thrive from '../images/others/thrive.PNG'
const data = [
    {
        url: bike,
        text: "Taking out my bike and hit the road"
    },
    {
        url: boy,
        text: " Some random Chats "
     },
     {
        url: ground,
        text: "Watching Cricket on Sunny Day is paradise"
    },
     {
        url: cricket,
        text: "Love playing this Gentleman game"
    },
    {
        url: santosh,
        text: "Solo Hike"
    },
    {
        url: dev,
        text: "Developer Meet Up"
    },
    {
        url: thrive,
        text: "Giving back to Community as Volunteer Developer"
    },
    
    
]
export default data;